import { IResult, IRouteParam } from "../types";
import { getNotSubmitRevisionInformation } from "../utils";
import { dataStatus } from "app/publicDictionaryValues";

const solveReviseHighlight = async (props: IRouteParam): Promise<IResult> => {
  const { currfileStepData, prevfileStepData } = props;

  return {
    RevisionInformation: getNotSubmitRevisionInformation(props),
    ProcedureFiles: {
      ProcedureSavedIn: prevfileStepData.procedureSaveInCategoryID !== currfileStepData.procedureSaveInCategoryID,
      SavedInStatus: false,
      ClientServerPath: prevfileStepData.clientServerPath !== currfileStepData.clientServerPath,
      ServerPathStatus: false,
      LevelCChange: false,
      FileNameList: currfileStepData.procedureFiles
        .filter((curr) => {
          const prevFile = prevfileStepData.procedureFiles.find((prev) => prev.fileID === (curr.oldFileID ?? curr.fileID));
          if (!prevFile) return true;

          if (curr.isReviewed && curr.oldFileID) {
            curr.fileID = curr.oldFileID;
            return true;
          }
          // Include file if review status changed with return reason or file was returned
          return curr.isReviewed || (curr.dataStatusID === dataStatus.return && prevFile.isReviewed);
        })
        .map((i) => `file-${i.fileID}`),
    },
  };
};

export default solveReviseHighlight;
